require('./bootstrap');

require('../components/tagifyComponent');
